import { TrailCamHistorySectionRowSkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/display/trailcam/TrailCamHistorySectionRowSkeleton';
import { ContentLayout } from 'app/agriculture/components/ContentLayout/ContentLayout';

interface TrailCamHistorySectionSkeletonProps {
    rows?: number;
}
export function TrailCamHistorySectionSkeleton({ rows = 5 }: TrailCamHistorySectionSkeletonProps) {
    return (
        <ContentLayout includeSeparator>
            {Array.from({ length: rows }, () => 'row').map((row, i) => (
                <TrailCamHistorySectionRowSkeleton
                    // All the rows are identical so ordering shouldn't matter
                    // eslint-disable-next-line react/no-array-index-key
                    key={`${row}-${i}`}
                />
            ))}
        </ContentLayout>
    );
}
